import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { NgForm } from '@angular/forms';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { ExcelService } from 'src/app/service/excel-service';
import { FiltroProgramacaoCarregamento } from '../filter/filtro-programacao-carregamento';
import { CabecalhoRomaneioCliente, defaultRomaneioClienteDto, defaultRomaneioInfCertificado, ProgramacaoCarregamentoLista, RomaneioClienteDto, RomaneioInfCertificado } from '../../romaneio/interface/romaneio';
import { AngularDeviceInformationService } from 'angular-device-information';
import * as moment from 'moment';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { VeiculoLookupService } from '../../romaneio/service/veiculo-lookup-service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-programacao-carregamento-lista',
  templateUrl: './programacao-carregamento-lista.component.html',
  styleUrl: './programacao-carregamento-lista.component.css'
})
export class ProgramacaoCarregamentoListaComponent implements OnInit {

  isDesktop: boolean = false;
  bloqueiaAcao: boolean = true;
  CZ00COD: string = '';
  senhaAcesso: string = '';
  inputPesquisar: string = '';
  codigosRomaneios: string = '';
  codigoCarregamento: string = '';

  dadosInfCertificado: RomaneioInfCertificado = defaultRomaneioInfCertificado();
  tabelaUrItens: Array<any> = [];

  dadosEtapasRomaneio: RomaneioClienteDto = defaultRomaneioClienteDto();
  bloqueiaPlaca: boolean = false;

  filtroPrincipal: FiltroProgramacaoCarregamento;
  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltrados: Array<any> = [];
  tabelaPrincipalOriginal: Array<any> = [];

  editCZ00DTACAR: Date | undefined = undefined;
  editCZ00HRACAR: string = '';
  editCZ00COD: string = '';

  optionsComboBoxCarregamento: Array<ProgramacaoCarregamentoLista> = [];

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  formatBasic: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Basic;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  veiculoLookupColumns: Array<PoLookupColumn>;
  transportadoraLookupColumns: Array<PoLookupColumn>;

  constructor(
    private route: Router,
    private excelService: ExcelService,
    private poDialogService: PoDialogService,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private poNotificationService: PoNotificationService,
    private deviceInformationService: AngularDeviceInformationService,
    public transportadoraService: TransportadoraService,
    public veiculoLookupService: VeiculoLookupService,
  ){
    this.filtroPrincipal = new FiltroProgramacaoCarregamento(this.poStorageService);
    this.veiculoLookupColumns = this.veiculoLookupService.getColumnsFilter();
    this.transportadoraLookupColumns = this.transportadoraService.getColumnsFilter();
  };

  @ViewChild('advancedFilterModal'        , { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('dataHoraCarregamentoModal'  , { static: true }) dataHoraCarregamentoModal!: PoModalComponent;
  @ViewChild('editarDadosEtapaModal'      , { static: true }) editarDadosEtapaModal!: PoModalComponent;
  @ViewChild('modalInfCertificado'        , { static: true }) modalInfCertificado!: PoModalComponent;
  @ViewChild('formFiltroPrincipal'        , { static: true }) formFiltroPrincipal!: NgForm;
  @ViewChild('formInfCertificado'         , { static: true }) formInfCertificado!: NgForm;
  @ViewChild('formCodigoCarregamento'     , { static: true }) formCodigoCarregamento!: NgForm;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goTo.bind(this) },
      { label: 'Prog. Carregamento' },
    ],
  };

  public readonly optionsStatusRomaneio: Array<PoSelectOption> = [
    { value: "3", label: "Fat. sem Dados" },
    { value: "4", label: "A Carregar" },
    { value: "5", label: "Carregamento Autorizado" },
    { value: "6", label: "Carregado"},
    { value: "Z", label: "Finalizado" },
    { value: "T", label: "Todos" },
  ];

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    { property: 'CZ07STATUS' , label: ' ', type: 'subtitle', width: '2%',
      subtitles: [
        {value: 'P', color: 'color-08', content: 'P', label: 'Carregamento Pendente'},
        {value: 'F', color: 'color-10', content: 'F', label: 'Carregamento Finalizado'},
      ]
    },
    { property: 'CZ07CODIGO' , label: 'Cód. Carreg.' }  ,
    { property: 'DZ00DTACAR' , label: 'Data Carreg.'    , type: 'date'  , format: 'dd/MM/yyyy' },
    { property: 'CZ00HRACAR' , label: 'Hora Carreg.' }  ,
    { property: 'CZ00COD'    , label: 'Cód. Romaneio' } ,
    { property: 'DZ00DATA'   , label: 'Data'            , type: 'date'  , format: 'dd/MM/yyyy' },
    { property: 'CZ00CLIENT' , label: 'Cliente' }       ,
    { property: 'CA1NOME'    , label: 'Nome Cliente' }  ,
    { property: 'CZ00STATUS' , label: 'Status Romaneio' , type: 'label' ,
      labels: [
        { value: '3', color: 'color-07', label: 'Fat. sem Dados' },
        { value: '4', color: 'color-09', label: 'A Carregar' },
        { value: '5', color: 'color-10', label: 'Carregamento Autorizado' },
        { value: '6', color: 'color-10', label: 'Carregado' },
        { value: 'Z', color: 'color-05', label: 'Finalizado' },
      ]
    },
    { property: 'CZ00HORA'  , label: 'Hora' }           ,
    { property: 'CEE7PEDIDO', label: 'Ped Cliente' }    ,
    { property: 'CEE7PEDFAT', label: 'Ped Fat.' }       ,
    { property: 'NEE7PESOLI', label: 'Peso Lim.'        , type: 'number', format: '1.2-2' },
    { property: 'NPESOTOT'  , label: 'Peso Acum.'       , type: 'number', format: '1.2-2' },
    { property: 'DZ00DTLIB' , label: 'Dt. Liberação'    , type: 'date'  , format: 'dd/MM/yyyy' },
    { property: 'CZ00HRLIB' , label: 'Hr. Liberação' }  ,
    { property: 'CEE9PREEMB', label: 'Nº. Processo' }   ,
  ];

  public readonly tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Data e Hora Carreg.'  , icon: 'po-icon-calendar'        , action: this.openModalDataHoraCarregamento.bind(this) } ,
    { label: 'Editar Romaneio'      , icon: 'po-icon-edit'            , action: this.bttnEditarRomaneio.bind(this) },
    { label: 'Etiqueta Cliente'     , icon: 'po-icon-credit-payment'  , action: this.bttnEtiquetaCliente.bind(this) },
    { label: 'Editar Dados Etapa'   , icon: 'po-icon-clipboard'       , action: this.bttnEditarDadosEtapa.bind(this)  },
    { label: 'Validar Carregamento' , icon: 'po-icon-truck'           , action: this.bttnValidarCarregamento.bind(this) , disabled: this.disabledBttnValidarCarregamento.bind(this) },
    { label: 'Inf. Certificado'     , icon: 'po-icon-info'            , action: this.openModalInfCertificado.bind(this) },
  ];

  public readonly tabelaUrColumns: Array<PoTableColumn> = [
    { property: 'UR', label: 'Código UR', width: '100%' },
  ];

  public readonly optionsTratamento: Array<PoSelectOption> = [
    {value: '1', label: 'KD - Secagem Estufa'},
    {value: '2', label: 'HT - Tratamento Térmico'},
  ];

  public readonly optionsTecnico: Array<PoSelectOption> = [
    {value: '1', label: '01 - Mauro Murara'},
    {value: '2', label: '02 - Ronald'},
  ];

  ngOnInit(): void {
    this.isDesktop = this.deviceInformationService.isDesktop();

    this.romaneioService.getCarregamentosMEListaComboBox().subscribe((ret) => {
      this.optionsComboBoxCarregamento = ret.items;
    });
  };

  tabelaPrincipalLoad(): void {
    this.filtroPrincipal.setStorage();
    this.romaneioService.listaRomaneioCliente(this.filtroPrincipal.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return {...item};
      });
      this.tabelaPrincipalFiltrados = this.tabelaPrincipalItens;
      this.tabelaPrincipalOriginal = this.tabelaPrincipalItens;
      this.bloqueiaAcao = true;
    });
  };

  selecionaRegistro(): void {
    this.bloqueiaAcao = true;
    this.tabelaPrincipalOriginal.forEach((item)=>{
      if (item.$selected){
        this.bloqueiaAcao = false
      }
    })
  };

  changeFiltro(filtro: string): void {
    if (filtro.trim()){
      this.tabelaPrincipalFiltrados = this.tabelaPrincipalOriginal.filter(({CZ07CODIGO,CZ07STATUS,CZ00COD,DZ00DATA,CZ00CLIENT,CA1NOME,CZ00STATUS,CZ00HORA,CEE7PEDIDO,CEE7PEDFAT,DZ00DTLIB,CZ00HRLIB,CEE9PREEMB}) =>
        CZ07CODIGO.startsWith(filtro) || CZ07STATUS.startsWith(filtro) || CZ00COD.startsWith(filtro) || DZ00DATA.startsWith(filtro) || CZ00CLIENT.startsWith(filtro) || CA1NOME.startsWith(filtro) || CZ00STATUS.startsWith(filtro) || CZ00HORA.startsWith(filtro) || CEE7PEDIDO.startsWith(filtro) || CEE7PEDFAT.startsWith(filtro) || DZ00DTLIB.startsWith(filtro) || CZ00HRLIB.startsWith(filtro) || CEE9PREEMB.startsWith(filtro)
      )
    } else {
      this.tabelaPrincipalFiltrados = this.tabelaPrincipalOriginal
    }

    this.tabelaPrincipalItens = this.tabelaPrincipalFiltrados
  };

  bttnAdicionar(): void {
    let adicionar: boolean = false;
    this.codigosRomaneios = '';

    this.poDialogService.confirm({
      title: 'Adicionar Romaneios',
      message: `Deseja realmente adicionar os romaneios selecionados no carregamento ${this.codigoCarregamento}?`,
      confirm: () =>{
        this.tabelaPrincipalOriginal.map((item) => {
          if (item.$selected){
            if (item.CZ07CODIGO.trim().length){
              this.poNotificationService.warning(`O romaneio ${item.CZ00COD} já pertence ao carregamento ${item.CZ07CODIGO}.`)
            } else {
              if (item.CZ00STATUS === 'Z'){
                this.poNotificationService.warning(`O romaneio ${item.CZ00COD} não será adicionado ao carregamento ${this.codigoCarregamento} pois já está Finalizado.`)
              } else{
                adicionar = true;
                this.codigosRomaneios += item.CZ00COD+';'
              }
            }
          }
        })

        if (adicionar){
          this.codigosRomaneios = this.codigosRomaneios.substring(0,this.codigosRomaneios.length - 1)
          this.romaneioService.postProgramacaoCarregamento(this.codigosRomaneios,this.codigoCarregamento,"A",undefined,"").subscribe({
            next: () => {
              this.tabelaPrincipalLoad()
            }
          })
        }
      }
    })
  };

  bttnRemover(): void {
    let remover: boolean = false;
    this.codigosRomaneios = '';

    this.poDialogService.confirm({
      title: 'Remover Romaneios',
      message: `Deseja realmente remover do carregamento ${this.codigoCarregamento} os romaneios selecionados?`,
      confirm: () =>{
        this.tabelaPrincipalOriginal.map((item) => {
          if (item.$selected){
            if (!item.CZ07CODIGO.trim().length){
              this.poNotificationService.warning(`O romaneio ${item.CZ00COD} não está vinculado a nenhum Carregamento.`)
            } else {
              remover = true;
              this.codigosRomaneios += item.CZ00COD+';'
            }
          }
        })

        if (remover){
          this.codigosRomaneios = this.codigosRomaneios.substring(0,this.codigosRomaneios.length - 1)
          this.romaneioService.postProgramacaoCarregamento(this.codigosRomaneios,"","R",undefined,"").subscribe({
            next: () => {
              this.tabelaPrincipalLoad()
            }
          })
        }
      }
    })
  };

  bttnExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map((item)=>{
      return {
        'Status Carreg.': this.getStatusName(item.CZ07STATUS,'C'),
        'Cód. Carreg.':   item.CZ07CODIGO,
        'Data':           item.DZ00DTACAR?moment(item.DZ00DTACAR).locale('pt-br').format('DD/MM/YYYY'):"",
        'Hora':           item.CZ00HRACAR,
        'Booking':        item.CEECBKAGEN?item.CEECBKAGEN+" / "+item.CEECBOOK:"",
        'Romaneio':       item.CZ00COD,
        'Processo':       item.CEE9PREEMB,
        'Ordem':          item.CEE7PEDIDO,
        'Container':      item.CZ00COTNER,
        'Tara':           item.CZ00TARA,
        'Lacre':          item.CZ00SELOD,
        'Nota Fiscal':    item.CZ00NOTA,
        'Transportadora': item.CA4NOME,
        'Etiqueta':       item.CEE7XETIQ,
        'Marcas no Pct.': item.CA1ETIQMAD,       
      }
    });
    this.excelService.exportAsExcelFile(lista_excel,`Programacao_Carregamento`)
    
  };

  
  getStatusName(status: String, campo: string) {
    // campo - R=Romaneio/C=Carregamento
    if (campo === 'R'){
      if (status === '3') {
        return 'Faturado sem Dados'
      } else if (status === '4') {
        return 'A Carregar'
      } else if (status === '5') {
        return 'Carregamento Autorizado'
      } else if (status === '6') {
        return 'Carregado'
      } else {
        return ''
      }
    } else if (campo === 'C'){
      if (status === 'P') {
        return 'Pendente'
      } else if (status === 'F') {
        return 'Finalizado'
      } else {
        return ''
      }
    } else {
      return ''
    }
  };

  openModalDataHoraCarregamento(row: CabecalhoRomaneioCliente): void {
    this.editCZ00DTACAR = row.DZ00DTACAR;
    this.editCZ00HRACAR = row.CZ00HRACAR.replace(":","").replace(":","");
    this.editCZ00COD    = row.CZ00COD;
    this.dataHoraCarregamentoModal.open()
  };

  closeModalDataHoraCarregamento(): void {
    this.editCZ00DTACAR = undefined;
    this.editCZ00HRACAR = '';
    this.editCZ00COD    = '';
    this.dataHoraCarregamentoModal.close()
  };

  ConfirmaModalDataHoraCarregamento(): void {
    this.romaneioService.postProgramacaoCarregamento(this.editCZ00COD,"","E",this.editCZ00DTACAR,this.editCZ00HRACAR).subscribe({
      next: () => {
        this.closeModalDataHoraCarregamento();
        this.tabelaPrincipalLoad()
      }
    })
  };

  bttnEditarRomaneio(row: CabecalhoRomaneioCliente): void {
    this.route.navigateByUrl(`/estoque/expedicao/romaneio-cliente/cadastro/${row.CZ00COD}/prog`);
  };

  bttnEtiquetaCliente(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.getPdfRomaneio(row.CZ00COD).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${row.CZ00COD}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  };

  bttnEtiquetaClienteSelecionados(): void {
  this.tabelaPrincipalOriginal.forEach((item) => {
    if (item.$selected) {
      this.romaneioService.getPdfRomaneio(item.CZ00COD).subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileName = `ROMANEIO_${item.CZ00COD}.pdf`;

        const a = document.createElement("a");
        document.body.appendChild(a);

        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
      });
    }
  });
}

bttnEmailAssiginados(): void {

  const selecionados = this.tabelaPrincipalOriginal
    .filter(item => item.$selected);

  if (!selecionados.length) {
    return;
  }

  this.poDialogService.confirm({
    title: 'Enviar E-mail',
    message: `Deseja enviar e-mail para as transportadoras dos ${selecionados.length} carregamentos selecionados?`,
    confirm: () => {

      selecionados.forEach(item => {
        this.romaneioService
          .postEnviaPDFRomaneioTransportadora(item.CZ00COD)
          .subscribe();
      });

    }
  });
}


  bttnValidarCarregamento(row: CabecalhoRomaneioCliente): void {
    this.route.navigateByUrl(`/estoque/expedicao/romaneio-cliente/carregamento/${row.CZ00COD}/CL`);
 };

  disabledBttnValidarCarregamento(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS != '4';
  };

  bttnEditarDadosEtapa(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.getRomaneioClienteShort(row.CZ00COD).subscribe(romaneio => {
      this.dadosEtapasRomaneio = romaneio;
      if ((this.dadosEtapasRomaneio.CZ00STATUS === '3' || this.dadosEtapasRomaneio.CZ00STATUS === '4')) {
        this.bloqueiaPlaca = true;
      } else {
        this.bloqueiaPlaca = false;
      }
      this.editarDadosEtapaModal.open();
    });
  };

  public readonly salvarDadosRomaneio: PoModalAction = {
    action: () => {
      this.romaneioService.alterarDadosRomaneioCliente(this.dadosEtapasRomaneio).subscribe((ret) => {
        this.editarDadosEtapaModal.close();
      })
      this.bttnEmailAssiginados();
    },
    label: 'Salvar',
  };

  openModalInfCertificado(row: CabecalhoRomaneioCliente): void {
    this.dadosInfCertificado = defaultRomaneioInfCertificado();
    this.dadosInfCertificado.CZ00COD    = row.CZ00COD;
    this.dadosInfCertificado.CZ00NCERT  = row.CZ00NCERT;
    this.dadosInfCertificado.NQTDZ02UR  = row.NQTDZ02UR;
    this.tabelaUrItens = row.AURS.map((item) => {
      return {...item};
    });

    this.modalInfCertificado.open()
  };

  closeModalInfCertificado(): void {
    this.dadosInfCertificado = defaultRomaneioInfCertificado();
    this.tabelaUrItens = [];
    this.modalInfCertificado.close()
  };

  gravarModalInfCertificado(): void {
    if (!this.dadosInfCertificado.CZ02UR || !this.dadosInfCertificado.CZ00NCERT){
      this.poNotificationService.warning("Código UR ou N° Certificado não identificado.")
    } else{
      this.romaneioService.postInformacaoCertificadoRomaneio(this.dadosInfCertificado).subscribe({
        next: () => {
          this.closeModalInfCertificado();
          this.tabelaPrincipalLoad();
          this.poNotificationService.success("Informações gravadas com sucesso!")
        }
      })
    }
  };

  certificadosModalInfCertificado(): void {
    this.poDialogService.confirm({
      title: 'Gerar Certificado',
      message: 'Esta ação irá fazer o download do certificado de todas as URs. Deseja prosseguir?',
      confirm: () => this.baixarPDFCertificados()
    });
  };

  async baixarPDFCertificados() {
    var retBlob;

    for (var qtdUR = 1; qtdUR <= this.dadosInfCertificado.NQTDZ02UR; qtdUR++){
      retBlob = (await firstValueFrom(this.romaneioService.getPdfCertificados(this.dadosInfCertificado.CZ00COD,qtdUR)))

      var file = new Blob([retBlob], {type: 'application/pdf'});
      var fileName = `Certificado_${new Date().toLocaleString().replace(/:/g,"").replace("/","").replace("/","").replace(", ","_")}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    };

    this.closeModalInfCertificado()
  };

  URSelecionada(dados: RomaneioInfCertificado): void {
    this.dadosInfCertificado.CZ02UR   = dados.$selected?dados.UR:"";
    this.dadosInfCertificado.CZEXTKD  = dados.$selected?dados.CZEXTKD:"";
    this.dadosInfCertificado.CZEXTEC  = dados.$selected?dados.CZEXTEC:"";
    this.dadosInfCertificado.CZEXINF  = dados.$selected?dados.CZEXINF:"";

    if(this.dadosInfCertificado.CZEXTKD === ""){
      this.dadosInfCertificado.CZEXTKD = "2"
    }
    if(this.dadosInfCertificado.CZEXTEC === ""){
      this.dadosInfCertificado.CZEXTEC = "1"
    }
  };

  goTo(): void {
    this.route.navigateByUrl('')
  };

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  };

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
